import React from 'react';
import { Crown } from 'lucide-react';
import { getInitials, getSpaceColor } from './helpers';
import { useTranslation } from '../../../../contexts/LanguageContext';

const MobileSharingSpaceItem = ({ 
  space, 
  userId,
  isActive,
  onClick
}) => {
  const { t } = useTranslation();

  return (
    <div 
      className="flex flex-col items-center group relative cursor-pointer"
      onClick={onClick}
    >
      <div 
        className={`w-20 h-20 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-md relative ${
          isActive ? 'ring-4 ring-blue-500 ring-offset-2' : ''
        }`}
        style={{ backgroundColor: getSpaceColor(space) }}
      >
        {getInitials(space.name)}
        {space.admin_id === userId && (
          <div className="absolute -top-1 -right-1 bg-yellow-500 text-white rounded-full w-6 h-6 flex items-center justify-center">
            <Crown className="h-3 w-3" />
          </div>
        )}
      </div>
      <div className="mt-2 text-center max-w-[100px]">
        <div className="text-sm font-medium text-gray-800 truncate">{space.name}</div>
        <div className="text-xs text-gray-500">
          {space.members.filter(m => m.request_status === 'accepted').length}{' '}
          {space.members.filter(m => m.request_status === 'accepted').length === 1 
            ? t('sharesubs.members.member') 
            : t('sharesubs.members.member', { count: 2 })}
        </div>
      </div>
    </div>
  );
};

export default MobileSharingSpaceItem;